module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Rotalic.24ad3604.ttf";